// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"HistoryModal_formContainer__21OLU"};